
document.addEventListener(
    "DOMContentLoaded", () => {

        // Get and store the current active tab
        let currentTab = GetCurrentTab();

        // Initial Variables
        let filterButton = null;
        let filterButtonClick = null;
        let filterClose = null;
        let filterCloseClick = null;

        // Filter handlers
        let filterHandlers = [];

        // Whats On Filters
        let fromDate = '';
        let toDate = '';

        // Stories Filters
        let topicFilters = '';

        // Experiences Filters
        let categoryFilters = '';
        let seasonFilters = '';
        let noOfPeopleFilters = '';
        let durationFilters = '';

        // Setup the initial handlers for the explore tabs
        SetupExploreTabHandlers();

        // Setup the initial handlers for the default active tab.
        SetupHandlers();

        /// Function to setup the explore main tab handlers so you can switch between different explore types.
        /// Should ever only need to be called once.
        function SetupExploreTabHandlers() {

            // Get and store the current active tab
            currentTab = GetCurrentTab();

            // Add event listeners to the main tabs (both desktop and mobile versions).
            // Desktop Version
            const radioTabs = document.querySelectorAll('input[name="exp_tab_rad"]');
            if (radioTabs) {
                radioTabs.forEach(radioTab => {
                    radioTab.addEventListener('click', function () {
                        // Update the dropdown tab selected value based on the radioTab clicked value
                        const dropdownTab = document.querySelector('.exp-tab-select');
                        dropdownTab.value = radioTab.value;

                        // Set the current tab
                        currentTab = radioTab.value;

                        // Set the page to 1 when switching tabs, this is only relevant when we are not using filters, if we are using filters then the page will be reset in the API call to 1 anyway.
                        const apiList = document.querySelector('.api-list');
                        if (apiList) {
                            apiList.setAttribute('data-list-page', 0);
                        }

                        // Render the output
                        UpdateExploreTab(true);
                    });
                });
            }

            // Mobile Version
            const dropdownTab = document.querySelector('.exp-tab-select');
            if (dropdownTab) {
                dropdownTab.addEventListener('change', function () {
                    // Update the radio tabs active state based on the dropdownTab selected value
                    radioTabs.forEach(radioTab => {
                        radioTab.checked = (radioTab.value === dropdownTab.value);
                    });

                    // Set the current tab
                    currentTab = dropdownTab.value;

                    // Set the page to 1 when switching tabs, this is only relevant when we are not using filters, if we are using filters then the page will be reset in the API call to 1 anyway.
                    const apiList = document.querySelector('.api-list');
                    if (apiList) {
                        apiList.setAttribute('data-list-page', 0);
                    }

                    // Render the output
                    UpdateExploreTab(true);
                });
            }
        }

        function UpdateFilterButtons() {

            // Ensure they exist, they don't in the basic explore tab
            filterButton = document.querySelector('.filter-button');

            if (filterButton) {
                // Remove the old buttons handlers
                if (filterButtonClick) {
                    filterButton.removeEventListener('click', filterButtonClick);
                }

                // Add filter open and close buttons
                filterButtonClick = filterButton.addEventListener('click', event => {
                    event.preventDefault();

                    const filterRow = document.querySelector('.filter-row');
                    if (filterRow.style.display === 'none' || filterRow.style.display === '') {
                        filterRow.classList.add('active');
                    } else {
                        filterRow.classList.remove('active');
                    }
                });
            }

            // Ensure they exist, they don't in the basic explore tab
            filterClose = document.querySelector('.filter-close');

            if (filterClose) {
                // Remove the old buttons handlers
                if (filterCloseClick) {
                    filterClose.removeEventListener('click', filterCloseClick);
                }
                // Add the new handler
                filterCloseClick = filterClose.addEventListener('click', event => {
                    event.preventDefault();
                    const filterRow = document.querySelector('.filter-row').classList.remove('active');
                });
            }
        }

        /// This function is designed to remove all previous event handlers for all filters and reinitialize them based on the current active tab.
        /// This is necessary because when we switch tabs, the filters will be different and we need to ensure that the correct filters are being tracked and updated.
        function SetupHandlers() {
            // Clear all previous filter handlers
            filterHandlers.forEach(filterHandler => {
                filterHandler.element.removeEventListener(filterHandler.handlerType, filterHandler.handler);
            });

            // Clear the filter handlers array
            filterHandlers = [];

            // Add filter open button handler
            const filterOpenButton = document.querySelector('.filter-button');
            if (filterOpenButton) {
                const filterOpenButtonHandler = (event) => {
                    event.preventDefault();

                    const filterRow = document.querySelector('.filter-row');
                    if (filterRow.style.display === 'none' || filterRow.style.display === '') {
                        filterRow.classList.add('active');
                    } else {
                        filterRow.classList.remove('active');
                    }
                };
                filterOpenButton.addEventListener('click', filterOpenButtonHandler);
                filterHandlers.push({ element: filterOpenButton, handler: filterOpenButtonHandler, handlerType: 'click' });
            }

            // Add filter close button handler
            const filterCloseButton = document.querySelector('.filter-close');
            if (filterCloseButton) {
                const filterCloseButtonHandler = (event) => {
                    event.preventDefault();
                    document.querySelector('.filter-row').classList.remove('active');
                };
                filterCloseButton.addEventListener('click', filterCloseButtonHandler);
                filterHandlers.push({ element: filterCloseButton, handler: filterCloseButtonHandler, handlerType: 'click' });
            }

            // General load more button
            const loadMoreButton = document.querySelector('.api-list-more .btn');
            if (loadMoreButton) {
                const loadMoreHandler = (event) => {
                    event.preventDefault();
                    // Get the current page from the button's data attribute
                    const apiList = document.querySelector('.api-list');
                    const currentPage = parseInt(apiList.dataset.listPage) || 0;
                    const nextPage = currentPage + 1;
                    apiList.dataset.listPage = nextPage;

                    UpdateExploreTab(false, true);
                };
                loadMoreButton.addEventListener('click', loadMoreHandler);
                filterHandlers.push({ element: loadMoreButton, handler: loadMoreHandler, handlerType: 'click' });
            }

            if (currentTab.indexOf('all') > 0) {
                // There are no filters to worry about
            } else if (currentTab.indexOf('whatson') > -1) {
                // We need to get the from and to date filters

                let today = new Date().toISOString().split('T')[0];

                // From Date Input
                let fromDateInput = document.querySelector('#eve_from');
                if (fromDateInput) {
                    const fromDateHandler = (event) => {
                        fromDate = event.target.value;

                        // Set the min date for the to date input
                        if (fromDate) {
                            toDateInput.setAttribute('min', fromDate);
                        } else {
                            // Set the min as today
                            toDateInput.setAttribute('min', today);
                        }
                        UpdateExploreTab(false);
                    }
                    fromDateInput.addEventListener('change', fromDateHandler);
                    filterHandlers.push({ element: fromDateInput, handler: fromDateHandler, handlerType: 'change' });
                }

                // To Date Input
                let toDateInput = document.querySelector('#eve_to');
                if (toDateInput) {
                    const toDateHandler = (event) => {
                        toDate = event.target.value;
                        if (toDate) {
                            fromDateInput.setAttribute('max', toDate);
                        } else {
                            // Remove the max attribut if there is no to date set
                            fromDateInput.removeAttribute('max');
                        }
                        UpdateExploreTab(false);
                    }
                    toDateInput.addEventListener('change', toDateHandler);
                    filterHandlers.push({ element: toDateInput, handler: toDateHandler, handlerType: 'change' });
                }

            } else if (currentTab.indexOf('stories') > -1) {
                // We need to get the topic filters

                // Topic Select
                let topicSelect = document.querySelector('#sto_topic');
                if (topicSelect) {
                    const topicHandler = (event) => {
                        topicFilters = event.target.value;
                        UpdateExploreTab(false);
                    }
                    topicSelect.addEventListener('change', topicHandler);
                    filterHandlers.push({ element: topicSelect, handler: topicHandler, handlerType: 'change' });
                }

                // Topic Radio Buttons
                const topicRadios = document.querySelectorAll('input[name="sto_topic_rad"]');
                if (topicRadios) {
                    topicRadios.forEach(topicRadios => {
                        const topicRadioHandler = (event) => {
                            topicFilters = event.target.value;
                            UpdateExploreTab(false);
                        };
                        topicRadios.addEventListener('change', topicRadioHandler);
                        filterHandlers.push({ element: topicRadios, handler: topicRadioHandler, handlerType: 'change' });
                    });
                }

            } else if (currentTab.indexOf('experiences') > -1) {
                // We need to get the category, season, no of people and duration filters
                // Category Select
                let categorySelect = document.querySelector('#exp_category');
                if (categorySelect) {
                    const categoryHandler = (event) => {
                        categoryFilters = event.target.value;
                        UpdateExploreTab(false);
                    }
                    categorySelect.addEventListener('change', categoryHandler);
                    filterHandlers.push({ element: categorySelect, handler: categoryHandler, handlerType: 'change' });
                }

                // Category Radio Buttons
                const categoryRadios = document.querySelectorAll('input[name="exp_category_rad"]');
                if (categoryRadios) {
                    categoryRadios.forEach(categoryRadio => {
                        const categoryRadioHandler = (event) => {
                            categoryFilters = event.target.value;
                            UpdateExploreTab(false);
                        };
                        categoryRadio.addEventListener('change', categoryRadioHandler);
                        filterHandlers.push({ element: categoryRadio, handler: categoryRadioHandler, handlerType: 'change' });
                    });
                }

                // Season Select
                const seasonSelect = document.querySelector('#exp_seasons');
                if (seasonSelect) {
                    const seasonHandler = (event) => {
                        seasonFilters = event.target.value;
                        UpdateExploreTab(false);
                    };
                    seasonSelect.addEventListener('change', seasonHandler);
                    filterHandlers.push({ element: seasonSelect, handler: seasonHandler, handlerType: 'change' });
                }

                // Season Radio Buttons
                const seasonRadios = document.querySelectorAll('input[name="exp_seasons_rad"]');
                if (seasonRadios) {
                    seasonRadios.forEach(seasonRadio => {
                        const seasonRadioHandler = (event) => {
                            seasonFilters = event.target.value;
                            UpdateExploreTab(false);
                        };
                        seasonRadio.addEventListener('change', seasonRadioHandler);
                        filterHandlers.push({ element: seasonRadio, handler: seasonRadioHandler, handlerType: 'change' });
                    });
                }

                // No of People Select
                const noOfPeopleSelect = document.querySelector('#exp_people');
                if (noOfPeopleSelect) {
                    const noOfPeopleHandler = (event) => {
                        noOfPeopleFilters = event.target.value;
                        UpdateExploreTab(false);
                    };
                    noOfPeopleSelect.addEventListener('change', noOfPeopleHandler);
                    filterHandlers.push({ element: noOfPeopleSelect, handler: noOfPeopleHandler, handlerType: 'change' });
                }

                // No of People Radio Buttons
                const noOfPeopleRadios = document.querySelectorAll('input[name="exp_people_rad"]');
                if (noOfPeopleRadios) {
                    noOfPeopleRadios.forEach(noOfPeopleRadio => {
                        const noOfPeopleRadioHandler = (event) => {
                            noOfPeopleFilters = event.target.value;
                            UpdateExploreTab(false);
                        };
                        noOfPeopleRadio.addEventListener('change', noOfPeopleRadioHandler);
                        filterHandlers.push({ element: noOfPeopleRadio, handler: noOfPeopleRadioHandler, handlerType: 'change' });
                    });
                }

                let durationSelect = document.querySelector('#exp_duration');
                if (durationSelect) {
                    const durationHandler = (event) => {
                        durationFilters = event.target.value;
                        UpdateExploreTab(false);
                    };
                    durationSelect.addEventListener('change', durationHandler);
                    filterHandlers.push({ element: durationSelect, handler: durationHandler, handlerType: 'change' });
                }
            }
        }

        /// This should render the output of the API call.
        /// It will also handle the logic of which filters to include in the API call based on the current active tab and the selected filters for that tab.
        /// If we are using a filter then we only want to replace the api-list container,
        /// If we are switching tabs without using a filter then we want to replace the entire explore-content-ref container as this will include the filters for the new tab.
        function UpdateExploreTab(tabChange, loadedMore) {

            currentTab = GetCurrentTab();
            const apiList = document.querySelector('.api-list');
            const page = apiList ? apiList.dataset.listPage || 0 : 0;

            // Get the overlay and hide it if it is now a full reset.
            const overlay = document.querySelector('.overlay');
            if (!tabChange && overlay) {
                overlay.classList.add('active');
            }

            let tabUrl = currentTab;
            tabUrl = tabUrl + (tabUrl.includes('?') ? '&' : '?') + 'api=true';
            tabUrl = !tabChange ? `${tabUrl}&filtered=true` : tabUrl;
            tabUrl = page > -1 ? `${tabUrl}&page=${page}` : tabUrl;

            if (currentTab.indexOf('all') > 0) {
                // There are no filters to worry about
            } else if (currentTab.indexOf('whatson') > 0) {
                // We need to get the from and to date filters
                tabUrl = fromDate ? `${tabUrl}&startDate=${fromDate}` : tabUrl;
                tabUrl = toDate ? `${tabUrl}&endDate=${toDate}` : tabUrl;
            } else if (currentTab.indexOf('stories') > 0) {
                // We need to get the topic filters
                tabUrl = topicFilters ? `${tabUrl}&topic=${topicFilters}` : tabUrl;
            } else if (currentTab.indexOf('experiences') > 0) {
                // We need to get the category, season, no of people and duration filters
                tabUrl = categoryFilters ? `${tabUrl}&category=${categoryFilters}` : tabUrl;
                tabUrl = seasonFilters ? `${tabUrl}&season=${seasonFilters}` : tabUrl;
                tabUrl = noOfPeopleFilters ? `${tabUrl}&no_of_people=${noOfPeopleFilters}` : tabUrl;
                tabUrl = durationFilters ? `${tabUrl}&duration=${durationFilters}` : tabUrl;
            }

            const response = fetch(tabUrl)
                .then((response) => {
                    return response.text();
                })
                .then((data) => {
                    // Get the bounding container for the full listing panel including filters.
                    const listingContainer = document.querySelector(tabChange ? '.explore-content-ref' : '.api-list');

                    // Fully replace the listing container with the new content.
                    if (loadedMore) {
                        listingContainer.innerHTML += data;
                    } else {
                        listingContainer.innerHTML = data;
                    }

                    // Check to see if we have reached the max number of items to load, if we have then hide the load more button, if not then show it.
                    // Parse the HTML string into a document
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');

                    // Find the element and get the attribute
                    const countUpdateElem = doc.querySelector('.articles-list-count-update');
                    const maxReached = countUpdateElem ? countUpdateElem.getAttribute('data-list-max') : null;

                    const apiListMore = document.querySelector(".api-list-more"); // Pager for the list
                    if (apiListMore) {
                        if (maxReached) {
                            apiListMore.style.display = 'none';
                        } else {
                            apiListMore.style.display = 'block';
                        }
                    }

                    // Update the filter buttons to ensure they are working with the new content.
                    UpdateFilterButtons();

                    SetupHandlers();

                    // Remove the active class on the overlay. Get the overlay again, just in case
                    const overlay = document.querySelector('.overlay');
                    if (overlay) {
                        overlay.classList.remove('active');
                    }
                });
        }

        function GetCurrentTab() {
            let localCurrentTab =
                document.querySelector('.explore-template.manual-tab') ? document.querySelector('.explore-template.manual-tab').getAttribute('data-current-tab') :
                    document.querySelector('input[name="exp_tab_rad"]:checked') ? document.querySelector('input[name="exp_tab_rad"]:checked').value :
                        '';
            return localCurrentTab;
        }

    }

);
